import React from "react";
import { ProfileContainerStyled } from "./styled";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "navigations/withRouter";
import { userService } from "apiServices";
import { toast } from "react-toastify";
import { ROUTE_PATH } from "utils/constants/routePath";
import { MemberSwitchTypeWidget } from "widgets";
import {
  Buttons,
  Cards,
  Displays,
  Forms,
  Headers,
  Modals,
  Navigations,
} from "components";

class ProfileContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    const { authenRedux } = this.props;
    this.fetchData(`?member_type=${authenRedux.member_type_active}`);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.authenRedux &&
      this.props.authenRedux !== prevProps.authenRedux
    ) {
      this.fetchData(
        `?member_type=${this.props.authenRedux.member_type_active}`,
      );
    }
  }

  fetchData = async (query) => {
    let resArr = await Promise.all([
      userService.GET_MY_INSTRUMENT(query),
      userService.GET_MY_INSTRUMENT_APPOINTEMNT_LIST(),
      userService.GET_MY_REWARD_E_VOUCHER_LIST(),
    ]);
    if (resArr) {
      this.setState({
        instrumentData: resArr[0].data.docs,
        maintenanceInstrumentLatestDetail:
          resArr[1].data.length === 0 ? false : resArr[1].data[0],
        myRewardEVoucherData: resArr[2].data,
        isLoading: false,
        isBgLoading: false,
      });
    }
  };

  _handleAddInstrument = () => {
    this.setState({
      addInstrument: true,
      initialValues: "",
    });
  };

  _handleSubmitInstrument = async (values) => {
    const { authenRedux } = this.props;
    this.setState({
      isBgLoading: true,
    });
    let params = {
      ...values,
      instrument_type_code: values.instrument_type.value,
      instrument_type_en: values.instrument_type.labelEn,
      instrument_type_th: values.instrument_type.labelTh,
      product_code: values.product.value,
      product_en: values.product.labelEn,
      product_th: values.product.labelTh,
      method: "1",
      member_type: authenRedux.member_type_active,
    };
    let res = await userService.POST_MY_INSTRUMENT(params);
    if (res && res.status === 200) {
      toast.success(this.props.t("Transaction success", { ns: "common" }));
      this.setState({
        isLoading: true,
        isBgLoading: false,
        addInstrument: false,
      });
      this.fetchData(`?member_type=${authenRedux.member_type_active}`);
    } else {
      this.setState({ isBgLoading: false });
      toast.error(this.props.t("Transaction failed", { ns: "common" }));
      // this.setState({
      //   addInstrument: false,
      // });
    }
  };

  _handleOnDetail = (id) => {
    this.props.router.navigate({
      pathname: `${ROUTE_PATH.PROFILE_ME}/${id}`,
      search: `?warranty_type=2`,
    });
  };

  handleClickReward = (e) => {
    this.props.router.navigate(`${ROUTE_PATH.REWARD}/${e}`);
  };

  _handleEditInstrument = (e) => {
    this.setState({
      initialValues: { ...e },
      addInstrument: true,
    });
  };

  _handleUpdateInstrument = async (values) => {
    const { authenRedux } = this.props;
    this.setState({
      isBgLoading: true,
    });
    let params = { ...values };
    let id = params._id;
    let res = await userService.PUT_UPDATE_MY_INSTRUMENT(id, params);
    if (res && res.status === 200) {
      toast.success(this.props.t("Transaction success", { ns: "common" }));
      this.setState({
        isLoading: true,
        isBgLoading: false,
        addInstrument: false,
      });
      this.fetchData(`?member_type=${authenRedux.member_type_active}`);
    } else {
      this.setState({ isBgLoading: false, addInstrument: false });
      toast.error(this.props.t("Transaction failed", { ns: "common" }));
    }
  };

  _handleDeleteInstrument = (id) => {
    this.setState({
      isShowModal: true,
      delete_item: id,
    });
  };

  handleCloseModal = () => {
    this.setState({
      isShowModal: false,
      delete_item: "",
    });
  };

  _handleConfirmDelete = async (e) => {
    const { authenRedux } = this.props;
    this.setState({
      isBgLoading: true,
    });
    let res = await userService.DELETE_MY_INSTRUMENT(e);
    if (res && res.status === 200) {
      toast.success(this.props.t("Transaction success", { ns: "common" }));
      this.setState({
        isLoading: true,
        isBgLoading: false,
        isShowModal: false,
        addInstrument: false,
      });
      this.fetchData(`?member_type=${authenRedux.member_type_active}`);
    } else {
      this.setState({
        isBgLoading: false,
        isShowModal: false,
        addInstrument: false,
      });
      toast.error(this.props.t("Transaction failed", { ns: "common" }));
    }
  };

  render() {
    const { authenRedux, t } = this.props;
    const {
      isBgLoading,
      isLoading,
      addInstrument,
      instrumentData,
      maintenanceInstrumentLatestDetail,
      myRewardEVoucherData,
      initialValues,
      isShowModal,
      delete_item,
    } = this.state;
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("Profile", { ns: "common" }),
      },
    ];
    return (
      <ProfileContainerStyled>
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="profile_container">
          <Headers.PageHeader
            theme_center
            title={"PROFILE"}
            subTitle={"โปรไฟล์"}
          />
          <Displays.BGLoading visible={isBgLoading} />
          {isLoading ? (
            <Displays.Loading />
          ) : (
            <>
              {!addInstrument ? (
                <>
                  <div className="profile_detail">
                    <MemberSwitchTypeWidget type="4" />
                    {authenRedux &&
                      (authenRedux.member_type_active === "1" ? (
                        <Cards.UserInfo data={authenRedux} />
                      ) : (
                        <Cards.CorperateInfo
                          {...authenRedux.organization_detail}
                        />
                      ))}
                  </div>
                  <Cards.MyInstrument
                    data={instrumentData}
                    onAdd={this._handleAddInstrument}
                    onDetail={this._handleOnDetail}
                    onEdit={this._handleEditInstrument}
                  />
                  <div className="my_reward_title">
                    {t("My Reward", { ns: "profile" })}
                  </div>
                  {maintenanceInstrumentLatestDetail && (
                    <div className="booking_layout">
                      <Cards.MyInstumentTuneBooking
                        {...maintenanceInstrumentLatestDetail}
                      />
                    </div>
                  )}
                  {myRewardEVoucherData && myRewardEVoucherData.length > 0 && (
                    <div className="my_reward_card_wrap">
                      {myRewardEVoucherData.map((e, i) => (
                        <div
                          key={i}
                          className="my_reward_card"
                          onClick={() => this.handleClickReward(e._id)}
                        >
                          <Cards.MyRewardCard {...e} />
                        </div>
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <>
                  <Forms.AddInstrumentForm
                    onBack={() => {
                      this.setState({
                        addInstrument: false,
                      });
                    }}
                    initialValues={initialValues}
                    onSubmit={this._handleSubmitInstrument}
                    onUpdate={this._handleUpdateInstrument}
                    onDelete={this._handleDeleteInstrument}
                  />
                </>
              )}
              <div className="interested_sec">
                {/* <Forms.InterestedForm /> */}
              </div>
            </>
          )}
        </div>
        <Modals.BodyEmpty
          isShowModal={isShowModal}
          onCloseModal={this.handleCloseModal}
        >
          <div className="modal_delete">
            <div className="title">
              {t(
                "The history of this musical instrument will be permanently erased",
                { ns: "profile" },
              )}
            </div>
            <div className="btn_wrap">
              <div className="btn">
                <Buttons.BgStandard
                  theme_cancel
                  label={t("Cancel", { ns: "profile" })}
                  onClick={this.handleCloseModal}
                />
              </div>
              <div className="btn">
                <Buttons.BgStandard
                  theme_red
                  label={t("Confirm", { ns: "profile" })}
                  onClick={() => this._handleConfirmDelete(delete_item)}
                />
              </div>
            </div>
          </div>
        </Modals.BodyEmpty>
      </ProfileContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation(["profile"])(withRouter(ProfileContainer)));
